import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import queryString from 'query-string'
import _ from 'lodash';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v2/storefront/products',
  }),
  tagTypes: ['Product', 'Products'],
  endpoints: (builder) => ({
    getProduct: builder.query({
      query: ({product_slug}) => ({
        url: `/${product_slug}?include=variants,option_types&fields[option_values]=name`,
      }),
      transformResponse: (response, meta, arg) => {
        const { data, included } = response;

        const product_data = data?.attributes || {};
        const relationships = data?.relationships || {};

        const variants = relationships?.variants?.data || [];
        const parsed_variants = []
        if (included && included.length > 0 && variants.length > 0){
          variants.forEach((variant) => {
            const variant_data = included.find((item) => item.id === variant.id);
            if(variant_data){
              const v_data = _.cloneDeep(variant_data.attributes);
              v_data.id = variant_data.id;
              parsed_variants.push(v_data);
            }else{
              parsed_variants.push(_.cloneDeep(variant))
            }
          })
        }else{
          parsed_variants.push(...variants.map((variant) => _.cloneDeep(variant)));
        }

        return {
          id: data.id,
          type: data.type,
          ...product_data,
          variants: parsed_variants,
        }
      }
    })
  }),
});

export const {
  useGetProductQuery,
} = productApi;